export default __webpack_public_path__ + "static/media/DeleteIcon.9d69aa3d.svg";